import { CartService } from '@/services/CartService.js';
import { getProductPrice, getVariantSelected } from '@/utils/product.js';

export default {
  data() {
    return {
      cartService: new CartService({
        http: this.$http,
        auth: this.$auth,
        store: this.$store,
      }),
    };
  },
  computed: {
    cart() {
      return this.cartService?.cart;
    },
    isCartValid() {
      if (!this.cart?.Products) return true;
      return this.cart.Products.every((item) => {
        const variantSelected = item.Variant?.find((v) => v.Selected);
        return (
          variantSelected?.Available &&
          variantSelected?.Quantity >= item.Quantity
        );
      });
    },
    isDigitalCart() {
      if (!this.cart?.Products || this.cart.Products.length === 0) return false;
      return this.cart.Products.every((product) => {
        return ['digital', 'e-giftcard'].includes(product.Type);
      });
    },
    cartCarriers() {
      return this.cart?.Shipping?.Carrier;
    },
    cartRelayPoint() {
      return this.cart?.Shipping?.Carrier?.RelayPoint;
    }
  },
  methods: {
    openRightBarCart() {
      this.$store.commit('shared/menu/toggle', {
        tabActive: 2,
        open: true,
      });
    },
    addShippingInfoGtm() {
      const orderid = this.$route.query.orderid;
      this.$gtm.push({
        event: 'add_shipping_info',
        ecommerce: {
          currency: this.$localisation.appCurrency.CurrencyIsoCode,
          value: this.cart?.Total?.ToPay?.TaxIncl,
          transaction_id: orderid,
          shipping: this.cart?.Total?.Shipping?.TaxIncl || 0,
          coupon: this.cart?.Total?.Discount?.TaxIncl || 0,
          items: this.cart.Products?.map((product) => ({
            item_id: product.IdProduct,
            quantity: product.Quantity,
            price: getProductPrice(product),
            item_name: product.Description.Title,
            item_brand: product?.Brand?.Name || 'Jean Marc Philippe',
            item_variant: getVariantSelected(product),
          })),
        },
      });
    },
    addPaymentInfoGtm(payment_type) {
      const orderid = this.$route.query.orderid;
      this.$gtm.push({
        event: 'add_payment_info',
        ecommerce: {
          payment_type: payment_type,
          currency: this.$localisation.appCurrency.CurrencyIsoCode,
          value: this.cart?.Total?.ToPay?.TaxIncl,
          transaction_id: orderid,
          shipping: this.cart?.Total?.Shipping?.TaxIncl || 0,
          coupon: this.cart?.Total?.Discount?.TaxIncl || 0,
          items: this.cart.Products?.map((product) => ({
            item_id: product.IdProduct,
            quantity: product.Quantity,
            price: getProductPrice(product),
            item_name: product.Description.Title,
            item_brand: product?.Brand?.Name || 'Jean Marc Philippe',
            item_variant: getVariantSelected(product),
          })),
        },
      });
    },
  },
};
